import Crud from '../views/DispatchReason/Crud'
import Entity from '../views/DispatchReason/Add'

let routes = {
    path: '/dispatch_reasons',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/dispatch_reasons/add',
            name: 'NewDispatchReason',
            component: Entity,
            meta: {
                pageTitle: 'Motivo de Despacho',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Despacho',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/dispatch_reasons/edit/:id?',
            name: 'EditDispatchReason',
            component: Entity,
            meta: {
                pageTitle: 'Motivo de Despacho',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Motivo de Despacho',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/dispatch_reasons',
            name: 'list-dispatch-reasons',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Motivos de Despachos',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Motivos de Despachos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
